import React from "react";
import {
  Button,
  CardActions,
  CardContent,
  Typography,
} from "@material-ui/core";
import { useHistory, useLocation } from "react-router";
import { Dinero } from "dinero.js";
import {
  CardLoading,
  CardLoadingProps,
} from "../../../../components/card-loading";

interface EarningsTotalProps extends CardLoadingProps {
  total: Dinero;
}

export const EarningsTotal: React.FC<EarningsTotalProps> = ({
  total,
  ...props
}) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <CardLoading {...props} style={{ width: "200px", ...props.style }}>
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          Earnings
        </Typography>
        <Typography variant="h5" component="h2">
          {total.toFormat()}
        </Typography>
        <Typography color="textSecondary">Total</Typography>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          onClick={() => history.push(`${location.pathname}/summary`, location.state)}
        >
          View summary
        </Button>
      </CardActions>
    </CardLoading>
  );
};
